import Choose from "./Choose";
import Contact from "./Contact";
import Footer from "./Footer";
import Header from "./Header";
import Intro from "./Intro";
import Location from "./Location";
import Mobile from "./Mobile";
import Services from "./Services";

function Main() {
  return (
    <main className="main main-visible">
      <div className="main-inner">
        <Mobile />
        <Header />
        <Intro />
        <Services />
        <Choose />
        <Location />
        <Contact />
        {/* <Counter /> */}
        {/* <Review /> */}
        {/* <MoreInfo /> */}
      </div>
      {/* <Featured /> */}
      <Footer />
    </main>
  );
}

export default Main;

